import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-l-filter",
  "use": "icon-l-filter-usage",
  "viewBox": "0 0 165 165",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 165 165\" id=\"icon-l-filter\"><path d=\"m86.923 86.38 43.396-46.008A2 2 0 0 0 128.864 37H36a2 2 0 0 0-1.455 3.372l44.368 47.039v39.597l8.01-7.114zm-10.01 1.825L33.09 41.745A4 4 0 0 1 36 35h92.864a4 4 0 0 1 2.91 6.745l-42.851 45.43v33.618l-8.682 7.71a2 2 0 0 1-3.328-1.495z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol